import { call, put, takeEvery } from 'redux-saga/effects';
import { CreateLoad, ILoadMin, logisticsActionCreators, LogisticsActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { unallocatedProductsActionCreators } from '../../unallocatedProducts';
import { createLoad } from '../logisticsApi';

function* createLoadSaga(action: CreateLoad) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<ILoadMin> = yield call(createLoad, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setMinLoads([response.value]));
    yield put(unallocatedProductsActionCreators.remove(action.payload.unallocatedProducts.map(x => x.inventTransId)));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchCreateLoad() {
  yield takeEvery(LogisticsActionKeys.CREATE_LOAD, createLoadSaga);
}
